/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ active: NonNullable<unknown>, archived: NonNullable<unknown> }} Inventory_Products_CountInputs */

const en_inventory_products_count = /** @type {(inputs: Inventory_Products_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.active} active, ${i?.archived} archived)`)
};

const es_inventory_products_count = /** @type {(inputs: Inventory_Products_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.active} activos, ${i?.archived} archivados)`)
};

/**
* | output |
* | --- |
* | "({active} active, {archived} archived)" |
*
* @param {Inventory_Products_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_count = /** @type {((inputs: Inventory_Products_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_count(inputs)
	return es_inventory_products_count(inputs)
});